import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import { darkTheme, lightTheme, ediphorTheme } from './index';
import { useThemeStore } from '../../store/themeStore';

export function ThemeProvider({ children }: { children: ReactNode }) {
  const mode = useThemeStore((s) => s.mode);
  const theme = useMemo(() => {
    if (mode === 'dark') return darkTheme;
    if (mode === 'ediphor') return ediphorTheme;
    return lightTheme;
  }, [mode]);
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}

export function useThemeMode() {
  const mode = useThemeStore((s) => s.mode);
  const toggleTheme = useThemeStore((s) => s.toggleTheme);
  const setTheme = useThemeStore((s) => s.setTheme);
  return { mode, toggleTheme, setTheme };
}
